import React from 'react'
import Match from './match'
import Wrapper from '../../components/wrapper'
import GlobalStyles from '../../assets/styles/global'
const searchTournaments = props => {
  return (
    <>
      <GlobalStyles />
      <Wrapper>
        <Match {...props} />
      </Wrapper>
    </>
  )
}

export default searchTournaments
